import * as Yup from 'yup';
import { YupString } from '.';

export const addNewAdminSchema = Yup.object().shape({
  firstName: YupString,
  lastName: YupString,
  email: YupString.email(),
  // roles: Yup.array().min(1, INVALID_FIELDS.REQUIRED).of(Yup.number()),
  roles: YupString,
});

export const assignRoleSchema = Yup.object().shape({
  roles: YupString,
});
